import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({

});

const actionMenu = defineStyle({
  list: {
    minW: '120px',
    p: 1,
    borderRadius: '0',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'blue.500',
    _dark: {
      bg: 'tmtBlack',
      borderColor: 'orange.500',
    },
  },
  icon: {
    w: '1rem',
    textAlign: 'center',
    mr: '0.5em !important',
  },
  item: {
    bg: 'white',
    color: 'blue.500',
    _dark: {
      color: 'orange.500',
      bg: 'tmtBlack',
    },
    _hover: {
      bg: 'blue.500',
      color: 'white',
      _dark: {
        bg: 'orange.500',
        color: 'tmtBlack',
      },
    },
    _focus: {
      bg: 'blue.500',
      color: 'white',
      _dark: {
        bg: 'orange.500',
        color: 'tmtBlack',
      },
    },
  },
});

export default defineStyleConfig({
  baseStyle,
  defaultProps: {
    variant: 'actionMenu',
  },
  variants: {
    actionMenu,
  },
});
